import { Integration } from '../types'

export const INTEGRATIONS: Integration[] = [
  {
    id: 'supabase',
    name: 'Supabase',
    description:
      'Base de datos, autenticación y almacenamiento del Sistema AVA.',
    status: 'no_conectado',
    icon: 'Database',
  },
  {
    id: 'meta-lead-ads',
    name: 'Meta Lead Ads',
    description: 'Recibe automáticamente los leads de Facebook e Instagram.',
    status: 'no_conectado',
    icon: 'Megaphone',
  },
  {
    id: 'whatsapp',
    name: 'WhatsApp',
    description: 'Contacta con tus leads desde la ficha en un solo clic.',
    status: 'no_conectado',
    icon: 'MessageCircle',
  },
  {
    id: 'calendly',
    name: 'Calendly',
    description: 'Permite agendar reuniones desde tus landings y gracias.',
    status: 'no_conectado',
    icon: 'CalendarDays',
  },
  {
    id: 'kajabi',
    name: 'Kajabi',
    description: 'Sincroniza contactos con tus programas de formación.',
    status: 'proximamente',
    icon: 'GraduationCap',
  },
  {
    id: 'typeform',
    name: 'Typeform',
    description: 'Importa respuestas de formularios ya existentes.',
    status: 'proximamente',
    icon: 'ClipboardList',
  },
  {
    id: 'jotform',
    name: 'Jotform',
    description: 'Recibe envíos de Jotform como leads de tu CRM.',
    status: 'proximamente',
    icon: 'FileSpreadsheet',
  },
  {
    id: 'webhook',
    name: 'Webhook',
    description: 'Envía cada nuevo lead a la URL que tú indiques.',
    status: 'no_conectado',
    icon: 'Webhook',
  },
  {
    id: 'gmail',
    name: 'Gmail',
    description: 'Envía correos a tus leads desde tu cuenta de Google.',
    status: 'no_conectado',
    icon: 'Mail',
  },
  {
    id: 'google-calendar',
    name: 'Google Calendar',
    description: 'Crea reuniones y recordatorios de seguimiento.',
    status: 'no_conectado',
    icon: 'Calendar',
  },
  {
    id: 'zapier',
    name: 'Zapier',
    description: 'Conecta AVA con más de 5.000 aplicaciones.',
    status: 'proximamente',
    icon: 'Zap',
  },
  {
    id: 'make',
    name: 'Make',
    description: 'Crea automatizaciones visuales con tus leads.',
    status: 'proximamente',
    icon: 'Workflow',
  },
  {
    id: 'smtp',
    name: 'Email SMTP',
    description: 'Envía notificaciones con tu propio servidor de correo.',
    status: 'no_conectado',
    icon: 'Send',
  },
]
